<template>
  <div :class="['overall-ratings',isSelectedSchoolPK?'pk':'',loading?'calculating-layout':'']">
    <template v-if="!isSelectedSchoolPK">
      <div class="column logo-desc before">
        <ImgFrameworkLogo/>
        <div class="desc-key">
          <div class="framework-desc">
            <h4>Framework for Great Schools</h4>
            <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
          </div>
        </div>
      </div>
      <div class="column left ratings">
        <div class="heading-wrapper">
          <h3 :class="{'covid-h3': isCovidYear}">Overall School Ratings</h3>
        </div>
        <p v-if="isCovidYear" class="covid-message mar-top-0">Due to COVID-19, ratings are not available for any schools for the {{ schoolYearRange }} school year.</p>
        <FrameworkRatings/>
        <FrameworkRatingsLegend
          v-if="!isCovidYear"
        />
      </div>
      <div class="column right logo-desc after">
        <ImgFrameworkLogo/>
        <div class="desc-key">
          <div class="framework-desc">
            <h4>Framework for Great Schools</h4>
            <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
          </div>
          <FrameworkRatingsLegend
            v-if="!isCovidYear"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="pk-framework-content">
        <div class="pk-header-wrapper">
          <h3>Framework for Great Schools</h3>
        </div>
        <div class="column logo-desc before">
          <ImgFrameworkLogo/>
          <div class="desc-key">
            <div class="framework-desc">
              <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
            </div>
          </div>
        </div>
        <div class="column left ratings pk">
          <FrameworkRatings/>
          <FrameworkRatingsLegend/>
        </div>
        <div class="column right logo-desc after pk">
          <ImgFrameworkLogo/>
          <div class="desc-key pk">
            <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
            <FrameworkRatingsLegend/>
          </div>
        </div>
        <div class="desc-pk-efq">In alignment with the Framework for Great Schools, the Division of Early Childhood Education (DECE) developed the Early Childhood Framework for Quality (EFQ). The EFQ is a birth-to-five framework applicable to all early childhood settings, including NYCEECs, Pre-K Centers, and District Schools. In the six areas of the Framework for Great Schools, you will see the corresponding Element of the EFQ referenced.</div>
        <!--
        <div v-if="isCovidYear" class="pk-covid-message">Our data collection for the 2019-2020 school year and the 2020-2021 school year was significantly disrupted due to COVID-19. For that reason, ECERS-R and CLASS scores do not appear on this year’s Snapshot, and many programs do not have school survey data. Missing data does not reflect the quality of any given program. To view the most recent ECERS-R and CLASS scores, please select a previous year from the dropdown above.</div>
        -->
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { NS_REPORT_GROUP, NS_CURRENT_REPORT } from './const'

import DivPrintableBackground from '@/components/DivPrintableBackground'
import ImgFrameworkLogo from '@/components/ImgFrameworkLogo'
import FrameworkRatings from './FrameworkRatings'
import FrameworkRatingsLegend from './FrameworkRatingsLegend'

@Component({
  computed: {
    ...mapGetters(NS_REPORT_GROUP, [
      'schoolYearRange'
    ]),
    ...mapGetters(NS_CURRENT_REPORT, [
      'isSelectedSchoolPK',
      'isCovidYear'
    ])
  },
  components: {
    DivPrintableBackground,
    ImgFrameworkLogo,
    FrameworkRatings,
    FrameworkRatingsLegend
  }
})
export default class OverallRatings extends Vue {
  loading = true // true on startup

  /* Lifecycle */

  mounted () {
    this.loading = false
  }
  updated () {
    this.loading = false
  }

  /* Watchers */

  @Watch('isSelectedSchoolPK')
  onSchoolChange (newVal, oldVal) {
    this.loading = true
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'src/styles/const.scss';
@import './css/const.scss';
$logo-size: 240px;
$logo-size-pk: 224px;
.overall-ratings {
  background-color: white;
  box-shadow: 0px 4px 5px #bbbbbb;
  display: flex;
  padding-bottom: 10px;
  margin-bottom: 15px;
  > * {
    flex: 1;
  }
  &.calculating-layout {
    .column.ratings {
      .framework-ratings-legend {
        visibility: hidden;
      }
    }
  }
  &:not(.calculating-layout) {
    .column.ratings {
      .framework-ratings-legend {
        display: none;
      }
    }
  }
  .heading-wrapper {
    > h3.covid-h3 {
      margin-bottom: 0;
    }
  }
  .covid-message {
    font-weight: bold;
    color: $alert-red-color;
  }
  .pk-covid-message {
    margin-top: 1.5em;
    color: $alert-red-color;
  }
  @media print {
    box-shadow: none;
  }
}
h3, h4 {
  margin-top: 0px;
}
.img-framework-logo {
  width: $logo-size;
  height: $logo-size;
  margin-right: 24px;
}
.column:not(.pk) {
  padding: 0px;
  margin: 0px 24px;
}
.column.left {
  margin-right: 12px;
}
.column.right {
  margin-left: 12px;
}
.column.logo-desc {
  display: flex;
  height: $logo-size;
  padding-top: 44px;
  .desc-key {
    min-width: 130px;
    max-width: 180px;
    position: relative;
    .framework-ratings-legend {
      position: absolute;
      bottom: 0px;
    }
  }
  .desc-key.pk {
    min-width: 150px;
  }
}
.column.logo-desc.after.pk {
  padding-top: 0px;
  height: $logo-size-pk;
  .img-framework-logo {
    width: $logo-size-pk;
    height: $logo-size-pk;
  }
}
.column.logo-desc.before {
  margin-bottom: 20px;
  .desc-key {
    flex: 1;
  }
}
.pk-framework-content {
  display: flex;
  flex-wrap: wrap;
  > * {
    flex:1;
  }
  .framework-desc {
    margin-top: 0px;
  }
  .instructions {
    margin-top: 4em;
    color: #2d89a0;
    &.menu {
      display: none;
    }
  }
}
.pk-header-wrapper {
  flex:100%;
}
.column.pk-legend {
  position: relative;
  .pk-legend-wrapper {
    position: absolute;
    max-width: 400px;
    bottom: 0px;
    right: 0px;
    background-color: #eeeeee;
    border-color: #eeeeee;
  }
  .pk-legend-content {
    padding: 16px;
    h4 {
      color: #777777;
    }
    .framework-ratings-legend {
      padding-left: 60px;
    }
  }
}
.desc-pk-efq {
  flex: 100%;
  padding-top: 8px;
}

.mar-top-0 {
  margin-top: 0;
}

/* Responsive rules */

.column.logo-desc.before {
  display: none;
}

.overall-ratings .pk-framework-content .framework-ratings-legend {
  visibility: hidden;
}
@media screen and (max-width: $screen-width-2-column-large) {
  /* Hide legend in right column */
.overall-ratings {
  &.calculating-layout {
    .column.logo-desc .framework-ratings-legend {
      visibility: hidden;
    }
  }
  &:not(.calculating-layout) {
    .column.logo-desc .framework-ratings-legend {
      display: none;
    }
  }
}
  /* Show legend in left column */
.overall-ratings {
  .column.left.ratings .framework-ratings-legend {
    display: flex;
  }
}
.column.ratings .framework-ratings-legend {
  width: 100%;
  box-sizing: border-box;
  /deep/ .title {
    margin-right: 24px;
  }
  /deep/ .legend-items {
    flex: 1;
    display: flex;
  }
  /deep/ .legend-item {
    padding-right: 24px;
    &:last-child {
      padding-right: 10px;
    }
    > * {
      display: block;
    }
  }
}
.column.logo-desc {
  padding-top: 0px;
}
.column.logo-desc.after {
  display: block;
  height: auto;
  > * {
    margin-left: auto;
    margin-right: auto;
  }
  .desc-key {
    min-width: 0px;
    max-width: none;
    margin-top: 10px;
  }
}
.column.logo-desc.after.pk {
  margin-top: 0px;
}
.pk-framework-content {
  > * {
    margin: auto;
  }
  .instructions {
    margin-top: 1em;
  }
}
.desc-pk-efq {
  padding-top: 18px;
}

}
@media screen and (max-width: $medium-screen-width) {
.column.ratings .framework-ratings-legend {
  /deep/ .legend-items {
    justify-content: space-between;
  }
  /deep/ .legend-item {
    padding-right: 0px;
  }
}
}
@media screen and (max-width: $screen-width-2-column-small) {
.column.left {
  margin-left: 10px;
  &.ratings.pk {
    margin-left: 0px;
  }
}
.column.right {
  margin-right: 10px;
  &.logo-desc.pk {
    margin-right: 0px;
  }
}
.overall-ratings {
  margin-bottom: 0px;
  padding-bottom: 30px;
}
.overall-ratings {
  .column.left.ratings .framework-ratings-legend {
    display: block;
  }
}
.pk-framework-content .column.logo-desc.before {
  margin-right: 0px;
  margin-left: 0px;
}
.pk-framework-content .instructions {
  &.tabs {
    display: none;
  }
  &.menu {
    display: block;
  }
}
}
@media screen and (max-width: $screen-width-1-column-large) {

.column.logo-desc.before {
  display: flex;
  height: auto;
  .desc-key {
    min-width: 0px;
    max-width: none;
  }
}
.overall-ratings {
  &.calculating-layout {
    .column.logo-desc.after {
      visibility: hidden;
    }
  }
  &:not(.calculating-layout) {
    .column.logo-desc.after {
      display: none;
    }
  }
  display: block;
  > .column, .pk-framework-content {
    max-width: $max-width-1-col;
    margin: auto;
  }
  .column.ratings .framework-ratings-legend {
    display: flex;
  }
}
.column.pk-legend {
  .pk-legend-wrapper {
    position: relative;
    margin: auto;
  }
}
.column.ratings .framework-ratings-legend {
  /deep/ .legend-items {
    justify-content: flex-start;
  }
  /deep/ .legend-item {
    padding-right: 24px;
  }
}
.pk-framework-content .instructions {
  margin-top: 1em;
}
}
@media screen and (max-width: $screen-width-1-column-medium) {
.overall-ratings {
  > .column {
    max-width: none;
    margin: 0px 10px;
  }
  .pk-framework-content .column.left.ratings.pk {
    margin: 0px;
  }
}
}
@media screen and (max-width: $screen-width-1-column-small) {
.column.logo-desc.before {
  display: block;
  > * {
    margin: auto;
  }
  .desc-key {
    margin-top: 10px;
  }
}
.overall-ratings:not(.pk) {
  .column.ratings .framework-ratings-legend {
    display: block;
  }
}
.column.ratings .framework-ratings-legend {
  /deep/ .legend-items {
    justify-content: space-between;
  }
  /deep/ .legend-item {
    padding-right: 0px;
  }
}
}
@media screen and (max-width: 370px) {
.column.ratings {
  margin: 0px;
  .heading-wrapper {
    margin: 0px 10px;
  }
  .covid-message {
    margin: 0 10px 10px 10px;
  }
  .framework-ratings-legend {
    padding: 0px 10px;
    /deep/ .legend-item:last-child {
      padding-right: 0px;
    }
  }
}
.overall-ratings .pk-framework-content .framework-ratings-legend {
  padding: 0px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2022/OverallRatings.vue